<template>
  <div
    v-if="successPage"
    class="two-factor-link-verification-success"
  >
    <img
      alt="Green badge with white checkmark"
      loading="lazy"
      height="45px"
      width="45px"
      src="@/assets/images/green-checkmark-badge.svg"
    >
    <header
      class="two-factor-link-verification-success-header"
    >
      The link was successfully verified
    </header>
    <p class="two-factor-link-verification-success-text">
      Please close this tab and continue with your Official USPS® Change-of-Address form.
    </p>
  </div>
</template>

<script>
import pageName from '../../utils/pageName';
import { getPageProperties, getContext } from '../../utils/analyticsHelpers';

export default {
  name: 'SmfaRedirect',
  data: () => ({
    successPage: true,
  }),
  async mounted() {
    window.analytics.page(pageName, getPageProperties(this.$route), getContext());

    const { coaUUID } = this.$route.params;
    if (coaUUID) {
      this.successPage = false;
      await this.redirectPage(coaUUID);
    }
  },
  methods: {
    async redirectPage(coaUUID) {
      this.$store.commit('ENABLE_LOADER');
      window.console.log('fetching smfa redirect url ....');
      const { smfaRedirect } = await this.$store.dispatch('mfa/smfaRedirectUrl', coaUUID);
      window.console.log(`smfa redirect url: ${smfaRedirect}`);
      if (smfaRedirect) {
        window.location.replace(smfaRedirect);
      } else {
        this.$router.push({ name: 'verification-failure' });
      }
    },
  },
};
</script>
<style>
.two-factor-link-verification-success {
  margin: auto;
  padding: 120px 20px 200px 20px;
  max-width: 446px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.two-factor-link-verification-success-header {
  padding: 10px 0 20px 0;
  color: var(--usps-digital-green);
  font-weight: 700;
  font-size: 1.25em;
}
.two-factor-link-verification-success-text {
  text-align: center;
}
</style>
